var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.272,
    height: 24.94,
    viewBox: "0 0 13.272 24.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M23.292,17.368l.688-4.487H19.674V9.967a2.246,2.246,0,0,1,2.535-2.421h1.953V3.763a23.8,23.8,0,0,0-3.473-.3c-3.541,0-5.864,2.148-5.864,6.054v3.42H10.89v4.487h3.935V28.211a16.1,16.1,0,0,0,2.429.189,15.889,15.889,0,0,0,2.421-.189V17.368Z",
    transform: "translate(-10.89 -3.46)",
    fill: "#a6a6a6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook11);
export default __webpack_public_path__ + "static/media/facebook (1) (1).fdff776e34756d496c201c862df2e3fe.svg";
export { ForwardRef as ReactComponent };